import env from '~/libs/env'

export default {
    createBorrower(data, experience, $axios, tenantId) {
        // Do not use option ids for the post
        data.useOptions = false
        data.append('jobifyAttribution', true)
        data.append('tenantId', tenantId)

        if (!data.get('interest') || data.get('interest') === null) {
            data.append('interest', 'marketplace')
        }
        return $axios.post(`${env('apiUrl')}/borrower-portal/borrower`, data)
            .then(res => {
                if (res.data.email) {
                    return res
                }

                let borrowerId = null
                let borrower = null
                let lendioJwt = null
                if (res.data && res.data.data) {
                    borrower = res.data.data.borrower || null
                    borrowerId = res.data.data.borrower.id || null
                    lendioJwt = res.data.data.lendioJwt || null
                }
                return { borrower, borrowerId, lendioJwt }
            })
    }
}
